module.exports = {
      id: "gallery-scope-usage",
      viewBox: "0 0 32 32",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#gallery-scope",
      toString: function () {
        return this.url;
      }
    }